import clsx from 'clsx'
import React, { FunctionComponent, ReactNode } from 'react'

import { Icon } from '../Icon'
import { ArcadeIconNames } from '../Icon/ArcadeIcon'
import { Heading, Text, TextSizes } from '../Typography'
import styles from './style.module.scss'

const INLINE_KINDS = {
  Info: 'Info',
  Error: 'Error',
} as const

type InlineKindsType = typeof INLINE_KINDS
type InlineKindsKeys = keyof InlineKindsType
export type InlineMessageKinds = InlineKindsType[InlineKindsKeys]

export interface MessageInlineProps {
  kind?: InlineMessageKinds
  heading?: string | ReactNode
  description?: string | ReactNode
  testNameSpace?: string
  headingSize?: TextSizes
  descriptionSize?: TextSizes
  iconName?: ArcadeIconNames
}

export const MessageInline: FunctionComponent<MessageInlineProps> = ({
  kind = INLINE_KINDS.Info,
  heading,
  description,
  testNameSpace = '',
  headingSize,
  descriptionSize,
  iconName,
}) => {
  if (typeof heading === 'undefined' && typeof description === 'undefined') {
    console.warn('MessageInline: Neither heading nor description was provided. Component will not render.')
    return null
  }

  const descriptionIsString = typeof description === 'string'
  const headingIsString = typeof heading === 'string'
  const hasTestId = testNameSpace.length > 0
  const dataTestIdProp = hasTestId && { 'data-testid': `${testNameSpace}-inline-message` }
  const testNameSpaceProp = hasTestId && { testNameSpace: `${testNameSpace}-inline-message` }
  const containerClassName = clsx(styles.inlineMessageContainer, {
    [styles.inlineMessageError]: kind === INLINE_KINDS.Error,
    [styles.inlineMessageInfo]: kind === INLINE_KINDS.Info,
  })

  return (
    <div className={containerClassName} {...dataTestIdProp}>
      {typeof iconName !== 'undefined' && (
        <div className={styles.iconContainer}>
          <Icon name={iconName} size={'Medium'} {...testNameSpaceProp} />
        </div>
      )}
      <div>
        {typeof heading !== 'undefined' &&
          (headingIsString ? (
            <Heading bold size={headingSize ?? 'S'} {...testNameSpaceProp}>
              {heading}
            </Heading>
          ) : (
            heading
          ))}
        <div className={styles.inlineMessageDescription}>
          {typeof description !== 'undefined' &&
            (descriptionIsString ? (
              <Text size={descriptionSize ?? 'XS'} {...testNameSpaceProp}>
                {description}
              </Text>
            ) : (
              description
            ))}
        </div>
      </div>
    </div>
  )
}
